import { useEffect, useState } from 'react';
import { get } from 'lodash';

import { FIELD_PATHS, FREQUENCY } from '@funnels/constants';
import { convert, formatToPrecision } from '@funnels/utils';

import { useFormValues } from '../useFormValues';

/**
 * this hook is used for updating the Joint Amount from current and partner applicant expense
 * @param expensesIndexList: Array[currentExpensesIndex, partnerExpensesIndex]
 * @param expenseCategoryIndListex: Array[currentExpensesExpenseIndex, partnerExpensesExpenseIndex]
 */
export const useUpdateExpenseJoinAmount = (expensesIndexList: number[], expenseCategoryIndexList: number[]): any => {
  const [jointAmount, setJointAmount] = useState<undefined | number>();

  const [formValues, setFormValues] = useFormValues();

  const [currentExpensesIndex, partnerExpensesIndex] = expensesIndexList;
  const [currentExpensesExpenseIndex, partnerExpensesExpenseIndex] = expenseCategoryIndexList;

  const currentExpensesExpenseAmount = get(
    formValues,
    FIELD_PATHS.EXPENSES_EXPENSE_AMOUNT(currentExpensesIndex, currentExpensesExpenseIndex)
  );
  const currentExpensesExpenseFrequency = get(
    formValues,
    FIELD_PATHS.EXPENSES_EXPENSE_FREQUENCY(currentExpensesIndex, currentExpensesExpenseIndex)
  );

  const partnerExpensesExpenseAmount = get(
    formValues,
    FIELD_PATHS.EXPENSES_EXPENSE_AMOUNT(partnerExpensesIndex, partnerExpensesExpenseIndex)
  );
  const partnerExpensesExpenseFrequency = get(
    formValues,
    FIELD_PATHS.EXPENSES_EXPENSE_FREQUENCY(partnerExpensesIndex, partnerExpensesExpenseIndex)
  );

  useEffect(() => {
    let monthlyAmount;

    if (currentExpensesExpenseAmount >= 0 && currentExpensesExpenseFrequency) {
      monthlyAmount = convert(currentExpensesExpenseAmount, currentExpensesExpenseFrequency, FREQUENCY.MONTHLY);
    }

    if (partnerExpensesExpenseAmount >= 0 && partnerExpensesExpenseFrequency) {
      monthlyAmount =
        monthlyAmount >= 0
          ? monthlyAmount + convert(partnerExpensesExpenseAmount, partnerExpensesExpenseFrequency, FREQUENCY.MONTHLY)
          : convert(partnerExpensesExpenseAmount, partnerExpensesExpenseFrequency, FREQUENCY.MONTHLY);
    }

    setJointAmount(monthlyAmount);
  }, [
    currentExpensesExpenseAmount,
    currentExpensesExpenseFrequency,
    partnerExpensesExpenseAmount,
    partnerExpensesExpenseFrequency,
  ]);

  function setJointAmountValue(groupAmount: any) {
    const amount = isFinite(Number(groupAmount)) ? formatToPrecision(Number(groupAmount) / 2, 2) : groupAmount;

    setFormValues(FIELD_PATHS.EXPENSES_EXPENSE_AMOUNT(currentExpensesIndex, currentExpensesExpenseIndex), amount);
    setFormValues(
      FIELD_PATHS.EXPENSES_EXPENSE_FREQUENCY(currentExpensesIndex, currentExpensesExpenseIndex),
      FREQUENCY.MONTHLY
    );

    setFormValues(FIELD_PATHS.EXPENSES_EXPENSE_AMOUNT(partnerExpensesIndex, partnerExpensesExpenseIndex), amount);
    setFormValues(
      FIELD_PATHS.EXPENSES_EXPENSE_FREQUENCY(partnerExpensesIndex, partnerExpensesExpenseIndex),
      FREQUENCY.MONTHLY
    );

    setJointAmount(groupAmount);
  }

  return [jointAmount, setJointAmountValue];
};
